export function cn(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(' ');
}

/** Build the desktop download route from the environment-specific website URL. */
export function getDesktopDownloadUrl(websiteUrl?: string): string {
  const baseUrl = websiteUrl?.trim().replace(/\/+$/, '') || 'https://daysheetly.com';
  return `${baseUrl}/download`;
}

export function formatToday(): string {
  return new Date().toISOString().split('T')[0];
}

export * from './config/capabilities';
export * from './config/featureFlags';
